<div class="grid mb-1 justify-content-center align-items-start" (dblclick)="onEditTransaction()">
    <!-- DEBIT on Left -->
    <div class="col-5">
        @if (isDebit) {
            <bm-customer-account-transaction-content [transaction]="transaction"></bm-customer-account-transaction-content>
        }
    </div>

    <!-- Middle Timeline Icon -->
    <div class="col-1 flex flex-column align-items-center">
    <span class="border-circle flex justify-content-center align-items-center"
          [ngClass]="isDebit ? 'bg-red-500' : 'bg-green-500'" [style]="{'width': '1.7rem', 'height': '1.7rem'}">
      <i class="fa-regular text-0 text-center"
         [ngClass]="isDebit ? 'fa-arrow-down-left' : 'fa-arrow-up-right'"></i>
    </span>
        <div class="h-full surface-400 mt-2" [style]="{'width': '2px', 'min-height': '2rem'}"></div>
    </div>

    <!-- CREDIT on Right -->
    <div class="col-5">
        @if (!isDebit) {
            <bm-customer-account-transaction-content [transaction]="transaction"></bm-customer-account-transaction-content>
        }
    </div>
</div>
